module.exports = __webpack_public_path__ + "static/img/heart.e3211915.png";